import { del, get, patch, post } from './client';
import type {
  BankAccount,
  Cart,
  CreateOrderPayload,
  LegalDocumentSummary,
  OrderConfirmation,
} from '@/types/cart';

export interface AddToCartPayload {
  productId: string;
  variantId?: string;
  quantity: number;
  addons?: Array<{ addonId: string; quantity: number }>;
}

export const cartApi = {
  get: () => get<Cart>('/cart'),
  addItem: (payload: AddToCartPayload) => post<Cart>('/cart/items', payload),
  updateItem: (
    itemId: string,
    payload: { quantity?: number; addons?: Array<{ addonId: string; quantity: number }> },
  ) => patch<Cart>(`/cart/items/${itemId}`, payload),
  removeItem: (itemId: string) => del<Cart>(`/cart/items/${itemId}`),
  setZone: (zone: string) => patch<Cart>('/cart/zone', { zone }),
  applyCoupon: (code: string) => post<Cart>('/cart/coupon', { code }),
  removeCoupon: () => del<Cart>('/cart/coupon'),
};

export const checkoutApi = {
  bankAccounts: () => get<BankAccount[]>('/bank-accounts'),
  legalDocuments: () => get<LegalDocumentSummary[]>('/legal-documents'),
  createOrder: (payload: CreateOrderPayload) =>
    post<OrderConfirmation>('/orders', payload),
  order: (orderNo: string, token: string) =>
    get<OrderConfirmation>(`/orders/${orderNo}`, { params: { token } }),
};
